module.exports = __webpack_public_path__ + "img/weather-night-cloud-rain.fd4b800e.png";